import {Folder} from 'lucide-react';

// A folder on CBS's FTP, shown by name.
export function FolderChip({name}: {name: string}) {
  return (
    <span className='inline-flex min-w-0 items-center gap-0.5 rounded-md align-[-2px] border bg-gray-50 px-1.5 py-0.5 text-xs font-medium text-gray-700'>
      <Folder className='h-3.5 w-3.5 shrink-0' />
      <span className='truncate'>{name}</span>
    </span>
  );
}
